import { Link, useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import React, { useCallback, useEffect, useRef } from 'react';
import Typography from '@material-ui/core/Typography';

import { customEvent } from '../../components/GoogleTagManager';
import {
	useHasCameraPermission,
	useIsQrCodeRecognized,
} from '../../store/scanSession/selectors';
import { useThunk } from '../../utils/thunks';
import { validateDigimarc as validateDigimarcThunk } from '../../store/scanSession/thunks';
import CountdownTimer from '../../components/CountdownTimer';
import NoPermission from '../../components/NoPermission';
import TamperTesterHeader from '../../components/TamperTesterHeader';
import TapeThumbnail from './tape_thumbnail.svg';
import streamApi from '../../apis/stream';

function Step2() {
	const { t } = useTranslation();
	const theme = useTheme();
	const history = useHistory();
	const hasCameraPermission = useHasCameraPermission();
	const cancelRef = useRef(() => {});
	const validateDigimarc = useThunk(validateDigimarcThunk);

	const isQrRecognized = useIsQrCodeRecognized();

	useEffect(() => {
		if (isQrRecognized) {
			validateDigimarc();
		} else {
			history.push('/step1');
		}
	}, [validateDigimarc, isQrRecognized, history]);

	const onTimeout = useCallback(() => {
		customEvent('time_ends_step2');
		streamApi.stop();
		history.push('/step2/help');
	}, [history]);

	const onStart = useCallback(({ cancel }) => {
		cancelRef.current = cancel;
	}, []);

	const onTimerAlert = useCallback(() => {
		customEvent('time_starts_step2');
	}, []);

	if (!hasCameraPermission) {
		return <NoPermission />;
	}

	return (
		<>
			<TamperTesterHeader />
			<div id="stream_container">
				<CountdownTimer
					onStart={onStart}
					onTimerAlert={onTimerAlert}
					onTimeout={onTimeout}
				/>
			</div>
			<Container
				maxWidth="sm"
				style={{
					display: 'flex',
					flexDirection: 'column',
					flex: 1,
					justifyContent: 'space-between',
				}}
			>
				<Grid
					container
					spacing={1}
					style={{
						marginTop: theme.spacing(1),
						marginBottom: theme.spacing(3),
					}}
				>
					<Grid item xs={12}>
						<Typography variant="h4" component="h2">
							{t('step_2_screen.title')}
						</Typography>
					</Grid>
					<Grid container item xs={12} spacing={1}>
						<Grid item xs={2}>
							<img src={TapeThumbnail} alt="Digimarc Tape Thumbnail" />
						</Grid>
						<Grid item xs={10}>
							<Typography variant="body1">
								{t('step_2_screen.instructions')}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<Grid container spacing={1} style={{ marginBottom: theme.spacing(4) }}>
					<Grid item xs={12}>
						<Button
							component={Link}
							to="/step2/help"
							variant="outlined"
							color="default"
							fullWidth={true}
							disableElevation={true}
						>
							{t('step_2_screen.help')}
						</Button>
					</Grid>
					<Grid item xs={12}>
						<Button
							component={Link}
							to="/"
							variant="text"
							color="primary"
							fullWidth={true}
						>
							{t('step_2_screen.cancel')}
						</Button>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}

export default Step2;
